import { Component, OnInit, ViewChild } from '@angular/core';
import { Http } from '@angular/http';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import {Pipe} from '@angular/core';
import {IOption} from 'ng-select';
declare  const $;
import {ToastyService, ToastyConfig, ToastOptions, ToastData} from 'ng2-toasty';
import * as moment from 'moment/moment';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AlertComponent } from './../alert/alert.component';
import { Popup } from 'ng2-opd-popup';


@Component({
  selector: 'app-make',
  templateUrl: './make.component.html',
  styleUrls: ['./make.component.scss']
})

export class MakeComponent implements OnInit {
	search:any
	ListOfModelDetails=[];
	labourcostDetailsArray=[]
	ToolTip="Delete is not allowed since it is used in Model page";
	btnName:any='Submit';
	isValid:boolean = true;
	ListMakeDetails:any[] = [];
	msgtext:any;
	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	newmake:string;
	newMake_err:boolean=false;
	EditObjectId:any;
	@ViewChild('add') add: Popup;
 	@ViewChild('update') update: Popup;
	@ViewChild('Askdelete') Askdelete: Popup;
	@ViewChild('delete') delete: Popup;
	@ViewChild('duplicate') duplicate: Popup;
	deleteId:any;
	orgId:number;
	userId:number;
	loading:boolean=true;
	duplicateMessage:string = 'This Make Already Exists';
	isMakeListLoaded:boolean = false;
	isDeleteAvailabilityLoaded:boolean = false;
	//getmake={};
	constructor(private dialogService:DialogService,private http: Http,private toastyService:ToastyService,private toastyConfig: ToastyConfig,private router:Router,private route : ActivatedRoute) {}

	ngOnInit() {
		this.loading=true;
		this.isMakeListLoaded = false;
		this.isDeleteAvailabilityLoaded = false;
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	    	window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
	      this.orgId=this.route.params['value'].orgId;
	      this.userId=this.route.params['value'].userId;
	      console.log('OrgId '+ this.orgId);
	      console.log('UserId '+ this.userId);
		}
		
		this.getAllMakedetails();
		
		
			
			//this.checkTooltip();
	}

	getAllDetailsFromModel () {
  	let modelObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/JoinMakeModel', modelObj).subscribe(
	    res => {
	    
				let Response = res.json();
				console.log("ListOfModelDetails",Response)
			this.ListOfModelDetails=[];
	    	if(Response.length>0) {
	    		this.ListOfModelDetails = res.json();
			
				 //this.checkTooltip();
				 //this.getCount();
			
	    	} else {
					this.loading=false;
	    	}
	      
	    },(err) =>{
		
				this.loading=false;
	      this.getCount();
	      if(err.status != 200){
	        this.msgtext = "Unable to load the joinmmValue";
	        this.getWarningFunction(this.msgtext);
	      }
	    })
	}

	getlabourcostdetails(){
		let makeobj={
			'orgId':this.orgId
		}
		return this.http.post('/getLabourCostdetails',makeobj).subscribe(
			res=>{
				let response=res.json();
				console.log(response);
				if(response.length>0){
					this.labourcostDetailsArray=response;
					//this.checkTooltip();
				}else{
					this.loading=false;
				}
			
			},err=>{
				this.loading=false;
	      if(err.status != 200){
	        this.msgtext = "Unable to load the Value";
	        this.getWarningFunction(this.msgtext);
	      }
			}
		)
	}



	checkTooltip(){
	
		if(this.ListMakeDetails.length==0||this.ListMakeDetails.length==undefined){
this.getAllMakedetails();
		}else if(this.ListOfModelDetails.length==0||this.ListOfModelDetails.length==undefined){
			this.getAllDetailsFromModel();
		}else{
			for(let z=0;z<this.ListMakeDetails.length;z++){
				for(let i=0;i<this.ListOfModelDetails.length;i++){
					if(this.ListMakeDetails[z].make==this.ListOfModelDetails[i].makedetails[0].make){
						this.ListMakeDetails[z].status=true;
					}
				}
			}
			this.loading=false;
		}
	
	}


// 	deletemake(index,objectID){
// 		    
// 		for(let z=0;z<this.ListMakeDetails.length;z++){
// 			if(this.ListMakeDetails[z]._id==objectID){

// 	for(let i=0;i<this.labourcostDetailsArray.length;i++){
// 	if(z<this.labourcostDetailsArray.length){
// 		if(this.labourcostDetailsArray[i].makeId==objectID){
// 			this.ListMakeDetails[z].status = true;
// 			}
// 		}
// 			}
// 		}
// 	}
// 	for(let z=0;z<this.ListMakeDetails.length;z++){
// 		if(	this.ListMakeDetails[z].status ==true&&this.ListMakeDetails[z]._id==objectID){
// 				alert("this Make cannot be deleted as it is used in Labour Cost");
// 		}else if(this.ListMakeDetails[z].status ==false&&this.ListMakeDetails[z]._id==objectID){
// 				this.Delete(index,objectID)
// 		}
// 	}
// }

	showAlertForAddingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"ADD MAKE",message:"The Data added successfully"});
	}
	
	showAlertForUpdatingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"UPDATE MAKE",message:"The Data updated successfully"});
	}
	showAlertForDeletingdata(){
		this.dialogService.addDialog(AlertComponent,{title:"DELETE MAKE",message:"The Data deleted successfully"});
	}

	showDuplicatePopup(message) {
		this.duplicateMessage = message;
		this.duplicate.options = {
	        showButtons: false,
	        color: "#4180ab",
	        header: "Make"
	    };
	    this.duplicate.show(this.duplicate.options);
	}
	addOk() {
		this.add.hide();
	}

	updateOk() {
		this.update.hide();
	}

	deleteOk() {
		this.delete.hide();
	}

	duplicateOk() {
		this.duplicate.hide();
	}

	updateLoadingState() {
		this.loading = !(this.isMakeListLoaded && this.isDeleteAvailabilityLoaded);
	}

	getAllMakedetails () {
		    
		let makeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getMakedetails', makeObj).subscribe(
	    res => {
	        let ResponeMake = res.json();
			this.ListMakeDetails = ResponeMake;
			if(ResponeMake.length>0){
				this.getCount();
				this.isMakeListLoaded = true;
				this.loadDeleteAvailability();
			}else{
				this.isMakeListLoaded = true;
				this.isDeleteAvailabilityLoaded = true;
				this.updateLoadingState();
			}

	    },(err) =>{
			this.isMakeListLoaded = true;
			this.isDeleteAvailabilityLoaded = true;
			this.updateLoadingState();
			if(err.status != 200){
				this.msgtext = "Unable to load the Value";
				this.getWarningFunction(this.msgtext);
			}
	    })
  	}

	loadDeleteAvailability() {
		let makeIds = [];

		for(let i=0;i<this.ListMakeDetails.length;i++) {
			this.ListMakeDetails[i].status = false;
			this.ListMakeDetails[i].deleteBlockedReason = '';
			makeIds.push(this.ListMakeDetails[i]._id);
		}

		return this.http.post('/api/getMakeDeleteAvailability', {
			'ids':makeIds,
			'orgId':this.orgId
		}).subscribe(
			res => {
				let availabilityResponse = res.json().availability || {};

				for(let i=0;i<this.ListMakeDetails.length;i++) {
					if(availabilityResponse[String(this.ListMakeDetails[i]._id)] && availabilityResponse[String(this.ListMakeDetails[i]._id)].canDelete === false) {
						this.ListMakeDetails[i].status = true;
						this.ListMakeDetails[i].deleteBlockedReason = availabilityResponse[String(this.ListMakeDetails[i]._id)].reason || this.ToolTip;
					}
				}

					this.isDeleteAvailabilityLoaded = true;
					this.updateLoadingState();
			},(err) => {
					this.isDeleteAvailabilityLoaded = true;
					this.updateLoadingState();
				if(err.status != 200){
					this.msgtext = "Unable to validate delete availability";
					this.getWarningFunction(this.msgtext);
				}
			}
		)
	}

  	getCount(){
	   if(this.p < Math.ceil(this.ListMakeDetails.length/10)){
	     this.startingCount = (this.p-1)*10;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	     }
			 this.endingCount = this.p*10;
			 console.log('List Length '+ this.ListMakeDetails.length);
		console.log('List startingCount '+ this.startingCount);
		console.log('List endingCount '+ this.endingCount);
	   } else if(this.p == Math.ceil(this.ListMakeDetails.length/10)){
	     let count = this.ListMakeDetails.length%10;
	     this.startingCount = (this.p-1)*10;
	     this.endingCount = this.startingCount + count;
	     if(this.startingCount == 0){
	       this.startingCount = 1;
	       this.endingCount = count;
			 }
			 console.log('List Length '+ this.ListMakeDetails.length);
		console.log('List startingCount '+ this.startingCount);
		console.log('List endingCount '+ this.endingCount);
	   }
	  }

	  Inputmake() {
	  	if(this.newmake == "" || this.newmake == null || this.newmake == undefined) {
			this.newMake_err=true;
			this.isValid = false;
	  	} else {
			this.newMake_err=false;
			this.isValid = true;
	  	}
	  }
	  
  	addmake() {
  		this.loading=true;
	    if(this.newmake == "" || this.newmake == undefined || this.newmake == null||/^\s*$/.test(this.newmake)) {
		this.newMake_err=true;
	     
	      this.loading=false;
	    } else {
	    	if(this.EditObjectId == null || this.EditObjectId == undefined || this.EditObjectId == "") {
	    		let reqMakeObj = {
			        'make':this.newmake.trim().toLowerCase(),
			        'orgId':this.orgId,
			        'created_By':this.userId,
			        'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
				}
			    return this.http.post('/api/addmakeValue', reqMakeObj).subscribe(
			    res => {
			        let makeResponse = res.json();
			        if(makeResponse.message == 'This Make Already Exists') {
			          this.loading=false;
			          this.showDuplicatePopup('This Make Already Exists');
			        } else {
			          this.MYSQLEntryMakeAdd();
			        }
			    },(err) =>{
			    	this.loading=false;
			        if(err.status != 200){
			          this.msgtext = "Unable to Add the make Value";
			          this.getWarningFunction(this.msgtext);
			        }
			    })
	    	} else {
	    		let reqMakeObj = {
			        'make':this.newmake.trim().toLowerCase(),
			        'orgId':this.orgId,
			        'updated_By':this.userId,
			        'update_Date':moment.utc().format('YYYY:MM:DD h:mm:ss'),
			        'objectId':this.EditObjectId
			      }
			      return this.http.post('/api/UpdateMakedetails', reqMakeObj).subscribe(
			      res => {
			        let makeResponse = res.json();
			        if(makeResponse.message == 'This Make Already Exist') {
			          this.loading=false;
			          this.showDuplicatePopup('This Make Already Exists');
			        } else {
			          this.MYSQLEntryMakeUpdate();
			        }
			      },(err) =>{
			        this.loading=false;
			        if(err.status != 200){
			          this.msgtext = "Unable to Add the make Value";
			          this.getWarningFunction(this.msgtext);
			        }
			      })
	    	}

	    }
	    
	}

	MYSQLEntryMakeAdd() {
	    let reqMakeObj = {
	        'make':this.newmake.trim().toLowerCase(),
	        'orgId':this.orgId,
	        'created_By':this.userId,
	        'created_Date':moment.utc().format('YYYY:MM:DD h:mm:ss')
	    }
	    return this.http.post('/api/MYSQLaddmakeValue', reqMakeObj).subscribe(
	      res => {
	      
	        let makeResponse = res.json();
	        this.showAlertForAddingdata();
	        this.getAllMakedetails();
					this.Empty();
					this.loading=false;
	    },(err)=>{
	        this.loading=false;
	        this.msgtext = "Unable to Add the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
  	}


  	MYSQLEntryMakeUpdate() {
	    let reqMakeObj = {
	        'make':this.newmake.trim().toLowerCase(),
	        'orgId':this.orgId,
	        'updated_By':this.userId,
	        'update_Date':moment.utc().format('YYYY:MM:DD h:mm:ss'),
			'EditObjectId':this.EditObjectId
	    }
	    return this.http.post('/api/MYSQLUpdateMakeDetails', reqMakeObj).subscribe(
	      res => {
	       
	        let makeResponse = res.json();
	        this.showAlertForUpdatingdata();
	        this.getAllMakedetails();
					this.Empty();
					this.loading=false;
	    },(err)=>{
	        this.loading=false;
	        this.msgtext = "Unable to Add the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
  	}

	Editing(index, objectId) {
		this.Empty();
		this.EditObjectId = objectId;
		this.btnName = 'Update';
		for(let i=0;i<this.ListMakeDetails.length;i++) {
			if(this.ListMakeDetails[i]._id == objectId) {
				this.newmake = this.ListMakeDetails[i].make.toUpperCase();
			}
		}
		
	}

	Delete(index, deleteId, makeRow?) {
		if(makeRow && makeRow.status === true) {
			this.msgtext = makeRow.deleteBlockedReason || this.ToolTip;
			this.getWarningFunction(this.msgtext);
			return false;
		}

		this.Empty();
		this.deleteId = deleteId;
		this.Askdelete.options = {
	        showButtons: false, // You can hide this in case you want to use custom 
	        color: "#4180ab",
	        header: "Delete Make"
	    };
	    this.Askdelete.show(this.Askdelete.options);
	}

	No() {
		this.Askdelete.hide();
	}

	Yes() {
		this.Askdelete.hide();
		this.loading=true;
		let reqMakeObj = {
	        'deleteId':this.deleteId,
	        'orgId':this.orgId
	    }
	    return this.http.post('/api/deleteMakeDetails', reqMakeObj).subscribe(
	      res => {
	        let makeResponse = res.json();
			if(makeResponse && makeResponse.canDelete === false) {
				this.loading=false;
				this.msgtext = makeResponse.reason || this.ToolTip;
				this.getWarningFunction(this.msgtext);
				this.getAllMakedetails();
				return false;
			}
	        this.MYSQLDeletemake();
	    },(err)=>{
	        this.loading=false;
	        this.msgtext = "Unable to Add the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
	}

	MYSQLDeletemake() {
		let reqMakeObj = {
	        'deleteId':this.deleteId
	    }
		return this.http.post('/api/MYSQLdeleteMakeDetails', reqMakeObj).subscribe(
	      res => {
	        this.loading=false;
	        let makeResponse = res.json();
	      //   this.delete.options = {
		    //     showButtons: false, // You can hide this in case you want to use custom 
		    //     color: "#4180ab",
		    //     header: "Make Deleted"
		    // };
				// this.delete.show(this.delete.options);
				this.showAlertForDeletingdata();
		    this.deleteId="";
	        this.getAllMakedetails();
	        this.Empty();
	    },(err)=>{
	        this.loading=false;
	        this.msgtext = "Unable to Add the Value in mysql";
	        this.getWarningFunction(this.msgtext);
	    })
	}

	deletesuccessOk() {
		this.delete.hide();
	}

	Empty() {
		this.newmake="";
		this.EditObjectId="";
		this.newMake_err=false;
		this.btnName='Submit';
		this.isValid=true;
	}

	reset() {
		this.Empty();
	}

    getWarningFunction(errMsg) {
	    var toastOptions:ToastOptions = {
	        title: "Make",
	        msg: errMsg,
	        showClose: true,
	        timeout: 3000,
	        theme: 'bootstrap',
	        onAdd: (toast:ToastData) => {
	        },
	        onRemove: function(toast:ToastData) {
	        }
	    };
        this.toastyService.warning(toastOptions);
    }//getWarningFunction end here


  getSuccessFunction(successMsg){
    var toastOptions:ToastOptions = {
      title: "Make",
      msg: successMsg,
      showClose: true,
      timeout: 3000,
      theme: 'bootstrap',
      onAdd: (toast:ToastData) => {
      },
      onRemove: function(toast:ToastData) {
      }
    };
    this.toastyService.success(toastOptions);
  }//getSuccessFunction end here


}




// WEBPACK FOOTER //
// ./client/app/make/make.component.ts